import { z } from 'zod';

export const decimalStringSchema = z.string().regex(/^-?(?:0|[1-9]\d*)(?:\.\d+)?$/);
export const nonNegativeDecimalStringSchema = decimalStringSchema.refine(
  (value) => !value.startsWith('-'),
  'Must be non-negative',
);

export const factProvenanceSchema = z.enum([
  'customer_confirmed',
  'user_entered',
  'ai_extracted',
  'system_assumption',
  'supplier_confirmed',
  'regulatory_source',
  'derived',
]);

export const findingStatusSchema = z.enum(['pass', 'fail', 'review', 'unknown', 'stale']);

export const publicProposalResponseSchema = z.object({
  idempotencyKey: z.uuid(),
  action: z.enum(['accept', 'request_changes']),
  quotationVersion: z.number().int().positive(),
  selectedTierQuantity: z.number().int().positive().optional(),
  customerName: z.string().trim().min(1).max(120),
  customerRole: z.string().trim().max(120).optional(),
  comment: z.string().trim().max(2_000).optional(),
});

export type PublicProposalResponse = z.infer<typeof publicProposalResponseSchema>;

export * from './oem';
export * from './oem/development';
export * from './setup';
export * from './operations';
export * from './factory';
export * from './oem/public-label-ocr';
